// @module ProductInventoryByLocation
define('ProductProp65Warning.View'
,	[
		'product_prop65_warning_view.tpl'

	,	'Utils'
	,	'Backbone'
	,	'jQuery'
	,	'underscore'
	]
,	function (
        product_prop65_warning_view_tpl

	,	Utils
	,	Backbone
	,	jQuery
	,	_
	)
{
	'use strict';

	// @class ProductProp65Warning.View @extends Backbone.View
	return Backbone.View.extend({
		
		template: product_prop65_warning_view_tpl

	,	initialize: function (options)
		{
			this.isDisplayProp65Warning = options.isDisplayProp65Warning;
		}

		//@method getContext @return ProductProp65Warning.View.Context
	,	getContext: function getContext()
		{
			return {
				//@property {Boolean} isDisplayProp65Warning
				isDisplayProp65Warning: this.isDisplayProp65Warning
			};
		}
	});
});
